// Editor-side companion to RceContextStrip. One-line drop-in for the 5
// owner editors (Well, Rig Sheet, BHA, Drill String, Mud Program) that
// renders the active Engineering Session context above the editor body,
// or nothing at all when no session is bound.
//
//     <RceEditorStrip
//       ownerKey="wellProfile"
//       ownerLabel="Well Profile"
//       consumes={["project.operator","project.client","project.country","project.field"]}
//     />
//
// Reuses the generic RceContextStrip — editors do NOT need any state
// mutation from the RCE (they're the OWNERS of their respective modules),
// only a visible reminder of the upstream project / rig / well identity.

import React from "react";
import { useEngineeringSession } from "@/lib/rce/useEngineeringSession";
import { sessionToResolverCtx } from "@/lib/rce/useReportRceWiring";
import RceContextStrip from "./RceContextStrip";

export default function RceEditorStrip({ ownerKey, ownerLabel, consumes }) {
  const { session } = useEngineeringSession();
  if (!session) return null;
  if (!Array.isArray(consumes) || consumes.length === 0) return null;
  const ctx = sessionToResolverCtx(session);
  return (
    <RceContextStrip
      consumerKey={ownerKey}
      consumerLabel={ownerLabel}
      consumes={consumes}
      ctx={ctx}
    />
  );
}
